/**
 * frontend-log-interface.js
 * フロントエンドログ関連APIのI/F定義
 */

// プロトタイプ宣言追加メソッド
import '@/hrm-frontend/modules/functions/prototype-extends'

/**
 * フロントエンドログ関連APIのI/F定義クラス
 */
export default class FrontendLogApiInterface {
  /**
   * コンストラクター
   */
  constructor () {
    // ペイロード要素
    this.PAYLOAD_ITEM = {
      // 処理種別
      EXECUTE_TYPE: 'execute-type',
      // データ
      DATA: 'data'
    }
    // 処理種別
    this.EXECUTE_TYPE = {
      // 管理画面ログ登録
      REGIST_FRONTEND_LOG_SYSTEM: 'regist-frontend-log-system',
      // 求職者ログ登録
      REGIST_FRONTEND_LOG_SEEKER: 'regist-frontend-log-seeker',
    }
    // ペイロード初期値
    this.payload = {
      // 処理種別
      [this.PAYLOAD_ITEM.EXECUTE_TYPE]: '',
      // データ
      [this.PAYLOAD_ITEM.DATA]: {}
    }
  }

  /**
   * フロントエンドログ登録ペイロード作成
   * @param {Object} logData ログデータ
   * @return {Object} ペイロード
   */
  makeSendSystemLogPayload (logData) {
    try {
      // 処理種別：管理画面ログ登録
      this.payload[this.PAYLOAD_ITEM.EXECUTE_TYPE] = this.EXECUTE_TYPE.REGIST_FRONTEND_LOG_SYSTEM
      // リクエストデータ：ログデータ
      this.payload[this.PAYLOAD_ITEM.DATA] = logData
      // ペイロードを返す
      return this.payload
    } catch (error) {
      throw error
    }
  }

  /**
   * 求職者ログ登録ペイロード作成
   * @param {Object} logData ログデータ
   * @return {Object} ペイロード
   */
  makeSendSeekerLogPayload (logData) {
    try {
      // 処理種別：求職者ログ登録
      this.payload[this.PAYLOAD_ITEM.EXECUTE_TYPE] = this.EXECUTE_TYPE.REGIST_FRONTEND_LOG_SEEKER
      // リクエストデータ：ログデータ
      this.payload[this.PAYLOAD_ITEM.DATA] = logData
      // ペイロードを返す
      return this.payload
    } catch (error) {
      throw error
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/frontend-log/frontend-log-interface.js